module.exports = __webpack_public_path__ + "static/media/britishcouncil@2x.5f58f143.jpg";